import { render, staticRenderFns } from "./DetalheFornecedor.vue?vue&type=template&id=90c96132&scoped=true"
import script from "./DetalheFornecedor.vue?vue&type=script&lang=js"
export * from "./DetalheFornecedor.vue?vue&type=script&lang=js"
import style0 from "./DetalheFornecedor.vue?vue&type=style&index=0&id=90c96132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c96132",
  null
  
)

export default component.exports